export const single = {
  tableData: [
    {dicId: '3.2.5.1.1', questionKey: '关键字1;关键字2', level: '容易', content: '本题是单选题，有五个选项', optionA: '选项1', optionB: '选项2', optionC: '选项3', optionD: '选项4', optionE: '选项5', answer: 'E' },
    {dicId: '3.2.5.1.1', questionKey: '关键字1;关键字2', level: '困难', content: '本题是单选题，有四个选项', optionA: '选项1', optionB: '选项2', optionC: '选项3', optionD: '选项4', answer: 'D' }
  ],
  tableCols: [
    { label: '课程目录编号', prop: 'dicId', align: 'center', resizable: false },
    { label: '关键字', prop: 'questionKey', align: 'center', resizable: false },
    { label: '题目难度', prop: 'level', align: 'center', resizable: false, required: true },
    { label: '题干', prop: 'content', align: 'center', resizable: false, required: true },
    { label: '选项A', prop: 'optionA', align: 'center', resizable: false, required: true },
    { label: '选项B', prop: 'optionB', align: 'center', resizable: false, required: true },
    { label: '选项C', prop: 'optionC', align: 'center', resizable: false, required: true },
    { label: '选项D', prop: 'optionD', align: 'center', resizable: false, required: true },
    { label: '选项E', prop: 'optionE', align: 'center', resizable: false, required: true },
    { label: '正确答案', prop: 'answer', align: 'center', resizable: false, required: true }
  ]
}
export const multiple = {
  tableData: [
    {dicId: '3.2.5.1.1', questionKey: '关键字1;关键字2', level: '容易', content: '本题是多选题，有五个选项', optionA: '选项1', optionB: '选项2', optionC: '选项3', optionD: '选项4', optionE: '选项5', answer: 'A,E' },
    {dicId: '3.2.5.1.1', questionKey: '关键字1;关键字2', level: '困难', content: '本题是多选题，有四个选项', optionA: '选项1', optionB: '选项2', optionC: '选项3', optionD: '选项4', answer: 'A,C' }
  ],
  tableCols: [
    { label: '课程目录编号', prop: 'dicId', align: 'center',width:'120px', resizable: false },
    { label: '关键字', prop: 'questionKey', align: 'center', resizable: false },
    { label: '题目难度', prop: 'level', align: 'center', resizable: false, required: true },
    { label: '题干', prop: 'content', align: 'center', resizable: false, required: true },
    { label: '选项A', prop: 'optionA', align: 'center', resizable: false, required: true },
    { label: '选项B', prop: 'optionB', align: 'center', resizable: false, required: true },
    { label: '选项C', prop: 'optionC', align: 'center', resizable: false, required: true },
    { label: '选项D', prop: 'optionD', align: 'center', resizable: false, required: true },
    { label: '选项E', prop: 'optionE', align: 'center', resizable: false, required: true },
    { label: '正确答案', prop: 'answer', align: 'center', resizable: false, required: true }
  ]
}
export const judge = {
  tableData: [
    {dicId: '3.2.5.1.1', questionKey: '关键字1;关键字2', level: '困难', content: '本题是判断题', answer: '正确' },
    {dicId: '3.2.5.1.1', questionKey: '关键字1;关键字2', level: '困难', content: '本题是判断题', answer: '错误' }
  ],
  tableCols: [
    { label: '课程目录编号', prop: 'dicId', align: 'center',width:'120px', resizable: false },
    { label: '关键字', prop: 'questionKey', align: 'center', resizable: false },
    { label: '题目难度', prop: 'level', align: 'center', resizable: false, required: true },
    { label: '题干', prop: 'content', align: 'center', resizable: false, required: true },
    { label: '正确答案', prop: 'answer', align: 'center', resizable: false, required: true }
  ]
}
export const gap = {
  tableData: [
    {dicId: '3.2.5.1.1', questionKey: '关键字1;关键字2', level: '困难', content: '本题是填空题', optionA: '肝', optionB: '脂肪', optionC: '脾' },
  ],
  tableCols: [
    { label: '课程目录编号', prop: 'dicId', align: 'center',width:'120px', resizable: false },
    { label: '关键字', prop: 'questionKey', align: 'center', resizable: false },
    { label: '题目难度', prop: 'level', align: 'center', resizable: false, required: true },
    { label: '题干', prop: 'content', align: 'center', resizable: false, required: true },
    { label: '第一空正确答案', prop: 'optionA', align: 'center', resizable: false, required: true },
    { label: '第二空正确答案', prop: 'optionB', align: 'center', resizable: false, required: true },
    { label: '第三空正确答案', prop: 'optionC', align: 'center', resizable: false, required: true }
  ]
}
export const sort = {
  tableData: [
    {dicId: '3.2.5.1.1', questionKey: '关键字1;关键字2', level: '容易', content: '本题是排序题', optionA: '选项1', optionB: '选项2', optionC: '选项3', optionD: '选项4', optionE: '选项5', optionF: '选项6', answer: 'A,C,E,D,B,F' }
  ],
  tableCols: [
    { label: '课程目录编号', prop: 'dicId', align: 'center',width:'120px', resizable: false },
    { label: '关键字', prop: 'questionKey', align: 'center', resizable: false },
    { label: '题目难度', prop: 'level', align: 'center', resizable: false, required: true },
    { label: '题干', prop: 'content', align: 'center', resizable: false, required: true },
    { label: '选项A', prop: 'optionA', align: 'center', resizable: false, required: true },
    { label: '选项B', prop: 'optionB', align: 'center', resizable: false, required: true },
    { label: '选项C', prop: 'optionC', align: 'center', resizable: false, required: true },
    { label: '选项D', prop: 'optionD', align: 'center', resizable: false, required: true },
    { label: '选项E', prop: 'optionE', align: 'center', resizable: false, required: true },
    { label: '选项F', prop: 'optionF', align: 'center', resizable: false, required: true },
    { label: '正确答案', prop: 'answer', align: 'center', resizable: false, required: true }
  ]
}


// WEBPACK FOOTER //
// ./src/views/resource/json/templateExample.js